import React from 'react';
import PropTypes from 'prop-types';
import css from './Slider.module.scss';

const Slider = ({
  label,
  name,
  value,
  onChange,
  min = 0,
  max = 100,
  step = 1,
  disabled = false,
  required = false,
  error,
  suffix,
  className = '',
  showValue = true,
  labelPosition = 'top',
}) => {
  const handleChange = (e) => {
    onChange(e);
  };

  const percentage = ((value - min) / (max - min)) * 100;

  return (
    <div className={`${css.sliderContainer} ${className} ${css[`label-${labelPosition}`]}`}>
      {label && (
        <label className={css.label}>
          {label}
          {required && <span className={css.required}>*</span>}
        </label>
      )}
      <div className={css.sliderWrapper}>
        <input
          type="range"
          value={value}
          onChange={handleChange}
          min={min}
          max={max}
          step={step}
          disabled={disabled}
          name={name}
          className={`${css.slider} ${error ? css.error : ''}`}
          style={{ '--slider-progress': `${percentage}%` }}
        />
        {showValue &&
          <span className={css.valueDisplay}>
            {value}
            {suffix && <span className={css.suffix}>{suffix}</span>}
          </span>
        }
      </div>
      {error && <span className={css.errorMessage}>{error}</span>}
    </div>
  );
};

Slider.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  error: PropTypes.string,
  suffix: PropTypes.string,
  className: PropTypes.string,
  showValue: PropTypes.bool,
  labelPosition: PropTypes.oneOf(['top', 'left']),
};

export default Slider;
